module.exports = __webpack_public_path__ + "img/1440.1abd4141.jpg";